import { render, staticRenderFns } from "./UnsolvedPayments.vue?vue&type=template&id=681a4cf4&scoped=true&"
import script from "./UnsolvedPayments.vue?vue&type=script&lang=js&"
export * from "./UnsolvedPayments.vue?vue&type=script&lang=js&"
import style0 from "./UnsolvedPayments.vue?vue&type=style&index=0&id=681a4cf4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681a4cf4",
  null
  
)

export default component.exports